import { render, staticRenderFns } from "./authorityManagement.vue?vue&type=template&id=4d510308&scoped=true&"
import script from "./authorityManagement.vue?vue&type=script&lang=js&"
export * from "./authorityManagement.vue?vue&type=script&lang=js&"
import style0 from "./authorityManagement.vue?vue&type=style&index=0&id=4d510308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d510308",
  null
  
)

export default component.exports